import Request from "luch-request";
import { toast } from "./index.js";
// import { getCurrentInstance } from "vue";
import { baseURL, appSystemConfig, localeMap } from "@/app.config.js";
import { useUserStore } from "@/stores";
import i18n from "@/locale/index.js";

const { t } = i18n.global;
// const { proxy } = getCurrentInstance();

// console.log('proxy-----',proxy)

const http = new Request();
let isWeakNetwork = false;

http.setConfig((config) => {
  /* config 为默认全局配置 */
  config.baseURL = baseURL; /* 根域名 */
  return config;
});

// 断网检测
const checkNetwork = async () => {
  return new Promise((resolve, reject) => {
    uni.getNetworkType({
      success: (res) => {
        if (res.networkType === "none") {
          getApp().$openGlobalDialog({
            content: t("common.networkError"),
            btnText: t("reload"),
            type: "1",
          });
          reject("no network");
        } else {
          resolve(res.networkType);
        }
      },
      fail: () => {
        getApp().$openGlobalDialog({
          content: t("common.networkError"),
          btnText: t("reload"),
          type: "1",
        });
        // toast(t("common.noNetwork"), { icon: "error" });
        reject("no network");
      },
    });
  });
};

http.interceptors.request.use(
  async (config) => {
    // 可使用async await 做异步操作
    const userStore = useUserStore();
    const token = userStore.token;

    // 断网检测
    try {
      await checkNetwork();
    } catch (error) {
      return Promise.reject(error);
    }

    // GET防止浏览器缓存
    if (config.method === "get") {
      config.params["_t"] = new Date().getTime();
    }

    token && (config.header["token"] = token);
    config.header["lang"] = localeMap[uni.getLocale()];

    return config;
  },
  (config) => {
    // 可使用async await 做异步操作
    return Promise.reject(config);
  }
);

http.interceptors.response.use(
  (response) => {
    uni.hideLoading();
    const userStore = useUserStore();

    switch (response.data.code) {
      case "200": // 成功
        return response.data;
      case "4003": // token 异常
        userStore.onResetStatus();
        uni.reLaunch({
          url: "/pages/auth/login",
        });
        return Promise.reject(response);
      default:
        getApp().$openGlobalDialog({
          content: response.data.message || t("common.serverHot"),
          customerServiceText: t("customerService"),
          btnText: t("ok"),
          type: "2",
        });
        // toast(response.data.message || t("common.serverHot"));
        return Promise.reject(response);
    }
  },
  (response) => {
    uni.hideLoading();
    const userStore = useUserStore();

    /*  对响应错误做点什么 （statusCode !== 200） */
    if (response.statusCode) {
      toast(response.statusCode, {
        // #ifdef MP-WEIXIN
        icon: "error",
        // #endif
      });
    } else if (response.errMsg === "request:fail timeout") {
      //超时
      // toast(t("common.networkError"), {
      //   // #ifdef MP-WEIXIN
      //   icon: "error",
      //   // #endif
      // });
      getApp().$openGlobalDialog({
        content: t("common.networkError"),
        btnText: t("reload"),
        type: "1",
      });
    } else if (response.errMsg === "request:fail ") {
      // toast(t("common.serverHot"));
      getApp().$openGlobalDialog({
        content: t("common.serverHot"),
        customerServiceText: t("customerService"),
        btnText: t("ok"),
        type: "2",
      });
    } else if (response.errMsg === "no network") {
      // toast(t("common.noNetwork"), { icon: "error" });
      getApp().$openGlobalDialog({
        content: t("common.networkError"),
        btnText: t("reload"),
        type: "1",
      });
    }
    return Promise.reject(response);
  }
);

export default http;
